import React, { useContext, useEffect, useState } from 'react'
// import style from './Blogs.module.css'
import { useTranslation } from 'react-i18next'
import { LangContext } from '../context/LangContext'
import { Link, useNavigate } from 'react-router-dom'
import new1 from '../../assets/images/الخبر الأول.jpeg.webp'
import new2 from '../../assets/images/الخبر الثاني.webp'
import new3 from '../../assets/images/الهيئة السعودية للمدن الصناعية ومناطق التقنية.webp'
import new4 from '../../assets/images/SASO[1].jpg'
// import Slider from 'react-slick'
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/effect-fade"
import "swiper/css/autoplay"
import 'swiper/css/pagination'
import 'swiper/swiper-bundle.css';
import { EffectFade , Autoplay ,Pagination } from 'swiper/modules'
import dayjs from 'dayjs'
import api from './../../api/api';
import LoadingP from '../Loading/LoadingP.jsx'

export default function Blogs() {
      
    const { t } = useTranslation()
    let {language}= useContext(LangContext)
    const site = sessionStorage.getItem('desiredPage')
    const [currentSection] = useState(site==="company"? "consultancy":"")
    const [news, setNews] = useState([])
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()            

    const data = [
      {
        id: '1',
        date: '12/12/2024',
        name: t('latestNews.1'),
        image: new1
      },
      {
        id: '2',
        date: '29/12/2024',
        name: t('latestNews.2'),
        image: new2
      },
      {
        id: '3',
        date: '12/12/2024',
        name: t('latestNews.3'),
        image: new3
      },
      {
        id: '4',
        date: '10/03/2025',
        name: t('latestNews.4'),
        image: new4
      },
    ]

    const getNews = async() =>{
      setLoading(true)
      let {data} = await api.get('/news', {
      params: {
        type: currentSection,
      }
    })    
      if(site==='company' &&data.length<=0){
        navigate('/comingsoon')
      }
      else{
        setNews(data)
      }      
      setLoading(false)
    }

    useEffect(()=>{
      getNews()
    },[site])
      

  return <>
  {loading? <LoadingP/>:<div dir={language==='en'? '':'rtl'}>
                                      {/* header */}
    <div className="header-img py-5 overflow-hidden">
      <div className='w-90 mx-auto d-flex h-100 flex-column align-items-center justify-content-center'>
        <p data-aos="zoom-in" className='position-relative line text-center fs-2 fw-bold text-black d-flex align-items-center justify-content-center pb-3 mt-3 mb-5'>{t('newsText3')}</p>
        <div data-aos="fade-up" data-aos-delay="200" className='d-flex'>
          <Link to={'/'}className='text-hover trans3'>{t('navHome')}</Link>
          <span className='text-black px-2'>/</span>
          <p className='text-secondary'>{t('navMediaCenter')}</p>
        </div>
      </div>
    </div>  
    
                                      {/* content */}
    <div className='container-lg w-90 mx-auto'>
      <div className='pt-sm-5 pt-3 mt-3 mb-5 fw-medium'>
          <h3 data-aos="fade-up" data-aos-delay="1000" className='text-main2 position-relative line3 text-center w-fit fs-3 fw-bold mb-5'>{site==='company'? t('latestNews.textCo'):t('latestNews.text')}</h3>
          <Swiper dir='rtl' data-aos="fade-right" data-aos-delay="800" className="d-flex justify-content-between pb-5 cursor-grab"
            modules={[EffectFade, Autoplay, Pagination]}
            slidesPerView={1}
            slidesPerGroup={1}
            loop={true}
            autoplay={{
              delay: 1000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            breakpoints={{
              992: {
                slidesPerView: 3,
              },
              768: {
                slidesPerView: 2,
              },
            }}
            spaceBetween={40}
            direction="horizontal"
            speed={2000}
            pagination={{
              clickable: true,
            }}
            >
            {site==='company'?'': (data.map((item) => <SwiperSlide key={item.id} className="h-initial cardd">
              <div className='bg-white h-100 trans3 shadow-sm'>
                <div className='rem-12h overflow-hidden d-flex align-items-center'>
                  <img loading='lazy' className='w-100 scale2' src={item.image} alt={item.name} />
                </div>
                <div className='p-3 pt-2'>
                  <p className={`text-secondary small ${language === 'en' ? '': 'text-end'}`}>{item.date}</p>
                  <p className={`fw-medium py-2 lh-lg text-justify ${language === 'en' ? '': 'text-end'}`}>{t('latestNews.1')}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
            {news.map((item) => <SwiperSlide key={item.id} className="h-initial cardd">
              <div className='bg-white h-100 trans3 shadow-sm'>
                <div className='rem-12h overflow-hidden d-flex align-items-center'>
                  <img loading='lazy' className='w-100 scale2' src={item.image} alt={item.subject[language]} />
                </div>
                <div className='p-3 pt-2'>
                  <p className={`text-secondary small ${language === 'en' ? '': 'text-end'}`}>{dayjs(item.updated_at).format('DD/MM/YYYY')}</p>
                  <p className={`fw-medium py-2 lh-lg text-justify ${language === 'en' ? '': 'text-end'}`}>{item.description[language]}</p>
                </div>
              </div>
            </SwiperSlide>
          )}
        </Swiper>
      </div>
    </div>
  </div>}
  </>
}
